import videojs from 'video.js'
import en from 'video.js/dist/lang/en.json'

videojs.addLanguage('en', en)
videojs.addLanguage('en', {
  'Error': 'Error',
  'Error Code': 'Error Code',

  // custom english translations
  'subtitles off': 'Off',
  'captions off': 'Off',
  'audio off': 'Off',
  'Default': 'Default',
  'Unknown': 'Default',
  'subtitles_unavailable': 'Subtitles unavailable',
  'character_edge_style': 'Character edge style',
  'window_opacity': 'Window opacity',
  'window_color': 'Window color',
  'background_opacity': 'Background opacity',
  'background_color': 'Background color',
  'font_opacity': 'Font opacity',
  'font_size': 'Font size',
  'font_color': 'Font color',
  'font_family': 'Font family',
  'custom_setting': 'Custom settings',
  'Try again': 'Try again',
  'button_try_again_in': 'Try again in {1}',
  'too_many_streams_title': 'Too many streams',
  'stream_limit_exceeded_message':
    'Your subscription allows {1} simultaneous streams. Please stop playback on another device and try again.',
})
